/**
 * Pauses execution for a specified number of milliseconds.
 * Returns a promise that resolves after the delay.
 *
 * @param ms - Number of milliseconds to sleep
 * @returns A promise that resolves after the specified delay
 *
 * @example
 * ```ts
 * import { Sleep } from "@pdfking/tfunc"
 *
 * console.log('Starting...');
 * await Sleep(1000); // Wait 1 second
 * console.log('Done!');
 *
 * // Use in async generators
 * async function* delayedNumbers() {
 *   yield 1;
 *   await Sleep(100);
 *   yield 2;
 *   await Sleep(100);
 *   yield 3;
 * }
 * ```
 */
export const Sleep = (ms: number): Promise<void> =>
  new Promise(resolve => setTimeout(resolve, ms))
